import styled from 'styled-components';
import { Colors } from '../../styles/colors';

export const PopupOverlay = styled.div`
  position: fixed;
  z-index: 1000;

  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;

  pointer-events: ${(props) => props['open'] ? 'all' : 'none'};
  background-color: ${`${Colors.grayDark}E5`};

  padding: 2rem;

  transition: opacity 100ms ease-out;
  opacity: ${(props) => props['open'] ? '1' : '0'};
`;
